export const getTrackingParams = (
  includePageViewId: boolean = false,
): Record<string, string> => {
  // TODO: vivian params should be fixed later, refer to YVES request middleware
  // page_cat2 is always empty in tc_vars we should hardcode it based on category level
  // for category level 1 its empty and for level2 is 'list_page'
  const { page_cat1 = '', page_cat2 = '', yr = '' } = window?.tc_vars || {};

  const params: Record<string, string> = {
    'vivian[pageCat1]': page_cat1,
    'vivian[pageCat2]': page_cat2,
  };

  if (includePageViewId) {
    params.page_view_id = yr;
  }

  return params;
};

export const buildTrackingQueryParams = (
  includePageViewId: boolean = false,
): string =>
  new URLSearchParams(getTrackingParams(includePageViewId)).toString();
